<div class="card-head">
  <h1>{{ 'auth.Login' | translate }}</h1>
  <h3>{{ 'auth.login-title' | translate }}</h3>
</div>

<form [formGroup]="loginForm" (ngSubmit)='login()'>
  <mat-form-field class="form-group" hideRequiredMarker>
    <mat-label>{{ 'forms.Email' | translate }}</mat-label>
    <input matInput formControlName="email" maxlength="50">
    <mat-error *ngIf="hasError('email', 'required')">{{ 'forms.Required' | translate }}</mat-error>
    <mat-error *ngIf="hasError('email', 'invalid')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
    <mat-error *ngIf="hasError('email', 'pattern')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field class="form-group" hideRequiredMarker>
    <mat-label>{{ 'forms.Password' | translate }}</mat-label>
    <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" maxlength="50">
    <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
      <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    <mat-error *ngIf="hasError('password', 'required')">{{ 'forms.Required' | translate }}</mat-error>
  </mat-form-field>

  <div class="form-group mb-5">
    <div class="recaptcha-container">
      <re-captcha (resolved)="captcha = $event"></re-captcha>
    </div>
    <p class="invalid-feedback mt-2 d-block" *ngIf="!captcha && formSubmitted">
      {{ 'forms.Required' | translate }}
    </p>
  </div>

  <div *ngIf="errorMsg" class="form-group alert alert-danger">
    <p *ngFor="let item of errorMsg?.result?.errorMessages">{{item}}</p>
  </div>

  <div class="btn-container">
    <button mat-raised-button color="primary" class="w-100" [class.loading]='loading' [disabled]='loading'>
      {{ 'forms.login' | translate }}
    </button>
  </div>

  <div class="card-action">
    <a [routerLink]="['/forgetpassword']">{{ 'auth.Forget-password?' | translate }}</a>
  </div>
</form>
